import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Select, MenuItem, InputLabel, FormControl, Checkbox, ListItemText } from '@mui/material';
import {getGuilds} from "../DataPointValue/DataPointValueClient";
import {styled} from "@mui/material/styles";


    const GuildMultiSelect = ({ selectedGuilds, setSelectedGuilds }) => {
    //     const GuildMultiSelect = () => {
        const [guilds, setGuilds] = useState([]);
        // const [selectedGuilds, setSelectedGuilds] = useState([]);


        // Fetch data from the API
    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const response = await axios.get('/api/data'); // Replace with your API endpoint
    //             setGuilds(response.data);
    //         } catch (error) {
    //             console.error('Error fetching data:', error);
    //         }
    //     };


        // Fetch data from the API
        // useEffect(() => {
            const fetchGuilds = () =>
            getGuilds()

                .then(data => {
                    console.log("Guilds fetched")
                    console.log(data);
                    // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                    setGuilds(data);
            });

        useEffect(() => {
            console.log("This triggers gathering the guilds...");
            fetchGuilds();
        }, []);

    const handleChange = (event) => {
        setSelectedGuilds(event.target.value);
        console.log("Selected Guilds");
        console.log(event.target.value);
    };

        const handleClearField = () => {
            setSelectedGuilds([]);
            console.log("Guilds Cleared");
        };

        const NarrowMenu = styled('div')(({ theme }) => ({
            '& .MuiPaper-root': {
                width: 200, // Adjust this value to your desired dropdown menu width
            },
        }));

    return (
        <FormControl sx={{   width: 400}} >
            <InputLabel id="guild-multi-select-label"  onClick={handleClearField} >Select Guilds</InputLabel>
            <Select
                labelId="guild-multi-select-label"
                multiple
                value={selectedGuilds}
                onChange={handleChange}
                renderValue={(selected) => selected.join(', ')}
                variant="standard"
                // MenuProps={{
                //     // PaperProps: {
                //         style: {
                //             width: 200, // Adjust this value to make the dropdown menu narrower
                //         // },
                //     },
                // }}
                // MenuProps={{
                //     PaperProps: {
                //         className: NarrowMenu().props.className,
                //     },
                // }}
                MenuProps={{
                    // PaperProps: {
                        style: {
                            maxWidth: 200, // Adjust this value to make the dropdown menu narrower
                        },
                    // },
                }}
            >
                {guilds.map((guild) => (
                    <MenuItem key={guild.id} value={guild.name}>
                        <Checkbox checked={selectedGuilds.indexOf(guild.name) > -1} />
                        <ListItemText primary={guild.name} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default GuildMultiSelect;
